import { H1Flow, H2Flow } from '@monthio/react-components'
import styled from 'styled-components'

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;

	${(props) => props.theme.breakpoints.up('sm')} {
		gap: 28px;
	}
`
export const TitleAndListWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
`

export const IconAndItemWrapper = styled.div`
	display: flex;
	flex-direction: row;
	gap: 8px;
	align-items: center;
`

export const ListWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
`

export const H1WithoutMargin = styled(H1Flow)`
	margin: 0px;
`

export const H2WithoutMargin = styled(H2Flow)`
	margin: 0px;
`
